import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { BidListToggleService } from 'src/vehicles/services/bid-list-toggle/bid-list-toggle.service';
import { BidListToggleState, ClearAllSelectedVehiclesUuid, VehicleToggleState } from 'remarketing-angular-library';
import { TranslocoService } from '@jsverse/transloco';
import { SaComponent } from 'smartauction-frontend-micro-library';


@Component({
    selector: 'app-bidlist-action-bar',
    templateUrl: './bidlist-action-bar.component.html',
    styleUrls: ['./bidlist-action-bar.component.scss'],
    imports: []
})
export class BidlistActionBarComponent extends SaComponent implements OnInit {
  itemCount = 0;
  @Output() onActionSelected = new EventEmitter<string>();
  @Input() isCommonMultiCheckboxImplementationEnabled: boolean;
  generalErrorMessage: string;

  bidListActionBarTranslations = {
    ariaLabelBtnRemove: '',
    ariaLabelBtnCancel: '',
    remove: '',
    cancel: '',
    bidListYouSelected: '',
    textVehicle: '',
    textVehicles: '',
    bidListSelect: '',
    bidListRemove: '',
    bidListText: ''
  };

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly store: Store,
    private readonly bidListToggleService: BidListToggleService
  ) {
    super();
  }

  ngOnInit(): void {
    this.updateItemCount();
    this.getTranslations();
  }

  removeAllSelected() {
    this.onActionSelected.emit('REMOVE');
    this.generalErrorMessage = null;
  }

  cancel() {
    this.store.dispatch(new ClearAllSelectedVehiclesUuid());
    this.bidListToggleService.reset();
  }

  get showBidListActionBar() {
    return this.itemCount > 0;
  }

  updateItemCount() {
    if (this.isCommonMultiCheckboxImplementationEnabled) {
      this.store
        .select(VehicleToggleState.selectedVehicles)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(selectedVehicles => {
          this.itemCount = selectedVehicles.length;
        });
    } else {
      this.store
        .select(BidListToggleState.selectedVehicles)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(selectedVehicles => {
          this.itemCount = selectedVehicles.length;
        });
    }
  }

  getTranslations() {
    const keyParams = {
      'vehicles.bidListActionBar': {},
      common: {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translate => {
        this.bidListActionBarTranslations.ariaLabelBtnRemove = translate[0].ariaLabelBtnRemove;
        this.bidListActionBarTranslations.ariaLabelBtnCancel = translate[0].ariaLabelBtnCancel;
        this.bidListActionBarTranslations.remove = translate[1].btnRemove;
        this.bidListActionBarTranslations.cancel = translate[1].btnCancel;
        this.bidListActionBarTranslations.bidListYouSelected = translate[0].bidListYouSelected;
        this.bidListActionBarTranslations.textVehicle = translate[0].textVehicle;
        this.bidListActionBarTranslations.textVehicles = translate[0].textVehicles;
        this.bidListActionBarTranslations.bidListSelect = translate[0].bidListSelect;
        this.bidListActionBarTranslations.bidListRemove = translate[0].bidListRemove;
        this.bidListActionBarTranslations.bidListText = translate[0].bidListText;
      });
  }
}
